module.exports = __webpack_public_path__ + "a5c84f8cadf19a9a0c90c84e14b1ed2a.png";